import { apiV2 } from '../http';

export const getProcurementIntegrationDossier = procurementId =>
  apiV2.get(`/admin/integrations/procurements/${procurementId}`);

export const reprocessIntegration = payload => apiV2.post('/admin/integrations/reprocess', payload);

export const reprocessIntegrationBatch = payload =>
  apiV2.post('/admin/integrations/reprocess-batch', payload);
